import {Elements} from '@stripe/react-stripe-js'
import {loadStripe} from '@stripe/stripe-js'
import React, {ReactNode} from 'react'

const stripePublicKey = (process.env.REACT_APP_STRIPE_PK || '').trim()
const stripePromise = stripePublicKey ? loadStripe(stripePublicKey) : null

export function ElementsProvider(props: {children: ReactNode}) {
  if (!stripePromise) {
    return <>{props.children}</>
  }
  const options: any = {
    mode: 'setup',
    currency: 'eur',
    paymentMethodCreation: 'manual',
  }
  return (
    <Elements stripe={stripePromise} options={options}>
      {props.children}
    </Elements>
  )
}
